var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21.9999H4C3.46957 21.9999 2.96086 21.7892 2.58579 21.4141C2.21071 21.039 2 20.5303 2 19.9999V12.9999C2 12.4694 2.21071 11.9607 2.58579 11.5857C2.96086 11.2106 3.46957 10.9999 4 10.9999H7M14 8.99988V4.99988C14 4.20423 13.6839 3.44117 13.1213 2.87856C12.5587 2.31595 11.7957 1.99988 11 1.99988L7 10.9999V21.9999H18.28C18.7623 22.0053 19.2304 21.8363 19.5979 21.5239C19.9654 21.2115 20.2077 20.7768 20.28 20.2999L21.66 11.2999C21.7035 11.0132 21.6842 10.7206 21.6033 10.4421C21.5225 10.1637 21.3821 9.90617 21.1919 9.68739C21.0016 9.46861 20.7661 9.29381 20.5016 9.17509C20.2371 9.05638 19.9499 8.99659 19.66 8.99988H14Z",
    stroke: "white",
    strokeWidth: 1.99832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.2b6ab878372178d97fccdd675eb9b448.svg";
export { ForwardRef as ReactComponent };